import React from "react";
import { PRICING_TABS } from "./constants";
import { PRICING_CONSTANTS } from "../../config/constants";

const PricingHeader = ({
  activeTab,
  setActiveTab,
  handleSubmit,
  submitDisabled,
  isSubmitting,
}) => {
  return (
    <div className="toolbar">
      <div className="tabs">
        <button
          className={`tab ${activeTab === PRICING_TABS.PRICING ? "tab-active" : ""}`}
          onClick={() => setActiveTab(PRICING_TABS.PRICING)}
          type="button"
        >
          {PRICING_CONSTANTS.TAB_PRICING}
        </button>
        <button
          className={`tab ${activeTab === PRICING_TABS.PENDING ? "tab-active" : ""}`}
          onClick={() => setActiveTab(PRICING_TABS.PENDING)}
          type="button"
        >
          {/* <span className="pending-dot" /> */}
          {PRICING_CONSTANTS.TAB_PENDING_LIST}
        </button>
      </div>

      {activeTab === PRICING_TABS.PRICING && (
        <button
          className="submit-btn"
          type="button"
          data-testid="pricing-submit-btn"
          onClick={handleSubmit}
          disabled={submitDisabled}
        >
          {isSubmitting ? PRICING_CONSTANTS.SUBMITTING : PRICING_CONSTANTS.SUBMIT}
        </button>
      )}
    </div>
  );
};

export default React.memo(PricingHeader);